import React from "react";
import { Container } from "react-bootstrap";
import * as style from "./style.mod.scss";
import OrangeTick from "assets/images/Orangehack.svg";
import BlueTick from "assets/images/Bluehack.svg";
import BlueX from "assets/images/BlueX.svg";
import locale from "locales";

const ProductsComparison = ({ data }) => {


  return (

    <div className={`${style.productFeatures}`}>
      <Container>
        <div className={`${style.productFeaturesBox} ${style.productComparions}`}>
          <div className={style.pfContainer}>
            <div className={style.pfHeader}>
              <p className={`${style.titleAndDescription} ${style.firstColumn}`}></p>
              <p className={`${style.comparedProductMob} ${style.secondColumn}`}>{locale?.productFeatures?.castIron}</p>
              <p className={`${style.comparedProductMob} ${style.secondColumn}`}>{locale?.productFeatures?.stainlessSteel}</p>
            </div>
            <div className={style.pfData}>
              {data?.productsComparison.map((content, i) => {
                const { text, subtitle, otherProducers } = content;
                return (
                  <div className={style.pfContent} key={i}>
                    <div className={`${style.titleAndSubtitle} ${style.firstColumn}`} >
                      <p className={style.title}>{text}</p>
                      <p className={style.subTitle}>{subtitle}</p>
                    </div>
                    <div className={`${style.ourFeatures} ${style.secondColumn}`}>
                      <img src={OrangeTick} alt={locale.altText.orangeTick} />
                    </div>
                    <div className={`${style.comparedProductInfoMob} ${style.secondColumn}`}>{otherProducers == "tick" ? <img src={BlueTick} alt={locale.altText.blueTick} /> : <img src={BlueX} alt={locale.altText.remove} />}</div>

                  </div>
                );
              })}

            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ProductsComparison;